import lang from "@/views/modules/InstitutionalDocs/language/en";

let searchFieldsDef = {
    'document_title': {
        label: lang.LBL_DOCUMENT_TITLE,
    },
    'created_by': {
        label: lang.LBL_UPLOADED_BY,
        type:'selectcomponent',
        route: 'users',
        moduleName: 'Users',
        name: 'institutionaldoc_user_name',
        id: 'institutionaldoc_created_by',
    },
    'description': {
        label: lang.LBL_DESCRIPTION,
    },
    'status': {
        label: lang.LBL_REQUEST_STATUS,
        type:'select',
        field_infos:'ed_request_status'
    },
};
export default { searchFieldsDef }